<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="showCommissionsModal" :title="$t('Commissions')" size="lg" @show="onShow"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable modal-class="mobile-full-screen">
      <commission-tiers :model="model" show-minimum-commission-field/>
      <div class="row">
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="insurance_rate"/>
        </div>
        <div class="col-md-4">
          <currency-input-widget :model="model" attribute="lot_handling_charge"/>
        </div>
        <div class="col-md-4">
          <percentage-input-widget :model="model" attribute="rebate_rate"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>

  import {createNamespacedHelpers} from 'vuex';
  import ArtisioModal from "../../../../../core/components/artisio-modal/ArtisioModal";
  import CurrencyInputWidget from "../../../../../core/widgets/CurrencyInputWidget";
  import PercentageInputWidget from "../../../../../core/widgets/PercentageInputWidget";
  import CommissionTiers from "@/core/components/commission-tiers/CommissionTiers";
  import Commission from "@/core/components/commission-tiers/Commission.model";
  import CommissionForm from "@/modules/customer/models/CommissionForm.model";

  const {mapState, mapActions} = createNamespacedHelpers('inventory');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "CommissionsModal",
    components: {CommissionTiers, ArtisioModal, CurrencyInputWidget, PercentageInputWidget},
    data: () => {
      return {
        loading: false,
        model: new CommissionForm()
      }
    },
    computed: {
      ...mapState({
        showCommissionsModal: state => state.view.commissionsModal.show,
        editObject: state => state.view.commissionsModal.object,
        inventory: state => state.view.commissionsModal.inventory,
      }),
    },
    watch: {
      editObject() {
        if (this.editObject) {
          this.model = new CommissionForm({
            lot_handling_charge: this.editObject.lot_handling_charge,
            minimum_commission: this.editObject.minimum_commission,
            insurance_rate: this.editObject.insurance_rate,
            rebate_rate: this.editObject.rebate_rate,
            commissions: this.editObject.commissions.map(data => new Commission(data))
          })
        }
      },
      'model.rebate_rate'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.minimum_commission = 0;
          if (this.model.commissions && this.model.commissions.length > 0) {
            this.model.commissions[0].percent = 0;
          }
        }
      },
      'model.minimum_commission'(newValue) {
        if (newValue && parseFloat(newValue) > 0) {
          this.model.rebate_rate = 0;
        }
      },
      'model.commissions': {
        handler(commissions) {
          if (commissions && commissions.length > 0) {
            for (let commission of commissions) {
              if (commission.percent && parseFloat(commission.percent) > 0) {
                this.model.rebate_rate = 0;
                break;
              }
            }
          }
        },
        deep: true
      }
    },
    methods: {
      ...mapActions(['hideCommissionsModal', 'updateInventoryTerms']),
      async onSubmit() {
        let success = await this.$confirm(this.$i18n.t('Changing terms will trigger automatic recalculation of all associated invoices and settlements. Would you like to proceed?'));
        if (!success) {
          return
        }

        this.loading = true;
        let tmpData = this.model.toJSON()

        let
            response = await this.updateInventoryTerms({
              uuid: this.inventory.uuid,
              data: {
                commission_tiers: tmpData.commissions.map(commission => commission.toJSON()),
                minimum_commission: tmpData.minimum_commission,
                insurance_rate: tmpData.insurance_rate,
                lot_handling_charge: tmpData.lot_handling_charge,
                rebate_rate: tmpData.rebate_rate,
              }
            });
        this.loading = false;

        if (response.success) {
          this.hideCommissionsModal();
          this.$toast('success', this.$t('Commissions were successfully saved'));
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0]);
          } else if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            for (let index in response.body.commissions) {
              this.model.commissions[index].setMultipleErrors(response.body.commissions[index]);
            }
          }
        }
      }
      ,
      onShow() {
        this.showConfirmation = true;
      }
      ,
      onHidden() {
        this.model = new CommissionForm();
        this.hideCommissionsModal();
      }
      ,
    }
  }
</script>

<style lang="scss" scoped>
</style>

